// Shared contact info for marketing pages.
//
// Zwei Nummern, zwei Rollen — nicht verwechseln:
// - VITANARA_PHONE_*: der KI-Agent (Konrad & Ida). Erkennt registrierte
//   Rufnummern; funktioniert NUR nach erfolgter Anmeldung.
// - VITANARA_BERATUNG_*: menschliche Kundenberatung, für Interessenten
//   VOR der Anmeldung.
export const VITANARA_PHONE_DISPLAY = "0 4103 7044937";
export const VITANARA_PHONE_TEL = "+4941037044937";
export const VITANARA_BERATUNG_DISPLAY = "01579 - 2316531";
export const VITANARA_BERATUNG_TEL = "+4915792316531";
export const VITANARA_CONTACT_EMAIL = "info@vitanara.de";
